import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Config',
    component: () => import('../views/Config.vue'),
    // children: [
    //   {
    //     path: '/config',
    //     name: 'Config page',
    //     component: () => import('../views/Config.vue')
    //   },
    // ]
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
